// extracted by mini-css-extract-plugin
module.exports = {"container":"Callback_container__28Luk","modal":"Callback_modal__33YYj","text":"Callback_text__4KhUO"};